module.exports = __webpack_public_path__ + "assets/img/sp.ff91fc79.png";